import type { BridgeChartDrawing } from "../types/public";

export const BRIDGE_CHART_FIBONACCI_LEVELS = Object.freeze([0, 0.236, 0.382, 0.5, 0.618, 0.786, 1] as const);

export function normalizeFibonacciLevels(levels: readonly number[] | undefined): readonly number[] | undefined {
  if (levels === undefined) return undefined;
  if (levels.length !== BRIDGE_CHART_FIBONACCI_LEVELS.length ||
      levels.some((level, index) => !Number.isFinite(level) || level !== BRIDGE_CHART_FIBONACCI_LEVELS[index])) {
    throw new RangeError("BridgeChart Fibonacci levels must equal the canonical retracement levels.");
  }
  return Object.freeze([...levels]);
}

export function fibonacciLevels(drawing: BridgeChartDrawing): readonly number[] {
  return drawing.levels ?? BRIDGE_CHART_FIBONACCI_LEVELS;
}
